"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var ExtraFormData = /** @class */ (function () {
    function ExtraFormData() {
        this.favorited = null;
        this.favorites = null;
        this.favorited = false;
        this.favorites = new Array();
    }
    ExtraFormData_1 = ExtraFormData;
    ExtraFormData.fromJson = function (json) {
        return utils_1.factory(new ExtraFormData_1(), json || {});
    };
    var ExtraFormData_1;
    ExtraFormData = ExtraFormData_1 = tslib_1.__decorate([
        utils_1.StaticImplements()
    ], ExtraFormData);
    return ExtraFormData;
}());
exports.ExtraFormData = ExtraFormData;
//# sourceMappingURL=extra-form-data.js.map